import React, { useCallback } from 'react';
import VerifyWidget from '../components/VerifyWidget';

/**
 * /verify — fully white-labeled identity verification page.
 *
 * Query params:
 *   ?key=pk_test_...      Public/API key for the calling app (optional in standalone)
 *   ?customerId=...       External user ID
 *   ?embed=true           Strips the surrounding chrome for iframe embedding
 */
const VerifyPage = () => {
  const params = new URLSearchParams(window.location.search);
  const isEmbed = params.get('embed') === 'true';
  const apiKey = params.get('key') || process.env.REACT_APP_PUBLIC_KEY || '';
  const userId = params.get('customerId') || 'user_demo_001';

  const handleComplete = useCallback(
    (result) => {
      if (isEmbed && window.parent !== window) {
        window.parent.postMessage(
          { source: 'afrilink-verify', type: 'COMPLETE', data: result },
          '*'
        );
      }
    },
    [isEmbed]
  );

  const handleClose = useCallback(() => {
    if (isEmbed && window.parent !== window) {
      window.parent.postMessage(
        { source: 'afrilink-verify', type: 'CLOSE' },
        '*'
      );
    }
  }, [isEmbed]);

  if (isEmbed) {
    return (
      <div className="min-h-screen flex items-center justify-center p-2 bg-transparent">
        <VerifyWidget
          apiKey={apiKey}
          userId={userId}
          onComplete={handleComplete}
          onClose={handleClose}
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#fafaf8] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <VerifyWidget
          apiKey={apiKey}
          userId={userId}
          onComplete={handleComplete}
        />
        {!apiKey && (
          <p className="text-center text-[11px] text-gray-400 mt-4">
            Demo mode. Pass <code className="font-mono">?key=pk_test_…</code> to test against your app.
          </p>
        )}
      </div>
    </div>
  );
};

export default VerifyPage;
